import { render, staticRenderFns } from "./OrderConfirmModal.vue?vue&type=template&id=37c68056&scoped=true&"
import script from "./OrderConfirmModal.vue?vue&type=script&lang=js&"
export * from "./OrderConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderConfirmModal.vue?vue&type=style&index=0&id=37c68056&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c68056",
  null
  
)

component.options.__file = "OrderConfirmModal.vue"
export default component.exports